module.exports = __webpack_public_path__ + "static/media/LogoFroinNegro.856c132b.png";